module.exports = __webpack_public_path__ + "static/media/egt.5afb4f26.png";